<!-- No message for patient type switch when patient is a minor -->
